// extracted by mini-css-extract-plugin
export default {"container":"Article_container__v3I8O","topContainer":"Article_topContainer__Edhhw"};